import React, { useState } from "react";
import { ImgTopBtn } from "../buttons";
import YearWeekPicker from "../yearWeekPicker/yearWeekPicker";
import "./filterPopup.scss";

function FilterPopup({ onClose, onApplyTimePeriod, initialFilterOptions, skitChartYearWeekNum }) {
  // Define filterOptions state with a default year and no week selected.
  const [filterOptions, setFilterOptions] = useState(
    initialFilterOptions || { year: new Date().getFullYear(), week: null }
  );
  const [showYearWeekPicker, setShowYearWeekPicker] = useState(true);

  return (
    <div className="ranking-popup-filter-wrapper">
      <div className="ranking-popup-filter-body">
        <div className="ranking-top-container">
          <ImgTopBtn
            id="close-btn"
            imgTopBtnBorderRadius="25px"
            imgTopBtnText=" X Close"
            imgTopBtnWidth="100px"
            imgTopBtnTextFontSize="1.3rem"
            imgTopBtnnFontFamily="Roboto-Slab"
            imgTopBtnFontWeight="900"
            imgTopBtnFontColor="var(--color-bloodred)"
            extraImgTopBtnStyles={{ bottom: "20px" }}
            onClick={onClose}
          />
        </div>
        {/* Render YearWeekPicker if showYearWeekPicker is true */}
        {showYearWeekPicker && (
          <YearWeekPicker
            initialYear={filterOptions.year}
            initialWeek={filterOptions.week}
            onApply={(newFilters) => {
              setFilterOptions(newFilters);
              onApplyTimePeriod(newFilters);
              setShowYearWeekPicker(false);
              onClose();
            }}
            onCancel={() => setShowYearWeekPicker(false)}
          />
        )}
      </div>
    </div>
  );
}

export default FilterPopup;
